<style lang="scss" scoped>
// ::-webkit-scrollbar {
//   width: 0px;
// }

// ::-webkit-scrollbar-track {
//   display: none;
// }

/deep/ .custom-calendar.vc-container {
    --day-border: 1px solid #b8c2cc;
    --day-border-highlight: 1px solid #b8c2cc;
    --day-width: 90px;
    --day-height: 90px;
    --weekday-bg: #f8fafc;
    --weekday-border: 1px solid #eaeaea;

    border-radius: 0;
    width: 100%;

    & .vc-header {
        background-color: #f1f5f8;
        padding: 10px 0;
    }

    & .vc-weeks {
        padding: 0;
    }

    & .vc-weekday {
        background-color: var(--weekday-bg);
        border-bottom: var(--weekday-border);
        border-top: var(--weekday-border);
        padding: 5px 0;
    }

    & .vc-day {
        padding: 0 5px 3px 5px;
        text-align: left;
        height: var(--day-height);
        min-width: var(--day-width);
        background-color: white;

        &.weekday-1,
        &.weekday-7 {
            background-color: white;
        }

        &:not(.on-bottom) {
            border-bottom: var(--weekday-border);

            &.weekday-1 {
                border-bottom: var(--weekday-border);
            }
        }

        &:not(.on-right) {
            border-right: var(--weekday-border);
        }
    }

    & .vc-day-dots {
        margin-bottom: 5px;
    }

    .ivu-progress-bg {
        max-width: 100% !important;
    }


}
</style>
<template>
    <div>
        <Row>
            <Col span="18">
            <v-calendar class="custom-calendar max-w-full" ref="reservatecalendar" :masks="masks" :attributes="attributes"
                :first-day-of-week="2" :timezone="'UTC'" locale="en" disable-page-swipe is-expanded
                @transition-start="chooseOneDay">
                <template v-slot:day-content="{ day, attributes }">
                    <a @click="choseDayOne(day)">
                        <div class="flex flex-col h-full z-10 overflow-hidden">
                            <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
                            <div class="flex-grow overflow-y-auto overflow-x-auto">
                                <div v-for="(attr, index) in attributes" :key="index">
                                    <Tooltip content="BLUE for general，GREEN for express" placement="top"
                                        style="width:100%">
                                        <Row>
                                            <Col span="18"><Progress style="width:100%"
                                                :percent="(attr.customData.normalReservedQty / attr.customData.normalTotalQty) * 100"
                                                hide-info :stroke-color="['#2d8cf0', '#2d8cf0']" /></Col>
                                            <Col span="6" class="text-right color-666">
                                            {{ attr.customData.normalReservedQty }}/{{ attr.customData.normalTotalQty }}</Col>
                                        </Row>
                                        <Row>
                                            <Col span="18"><Progress style="width:100%"
                                                :percent="(attr.customData.valueAddReservedQty / attr.customData.valueAddTotalQty) * 100"
                                                hide-info status="success" /></Col>
                                            <Col span="6" class="text-right color-666">
                                            {{ attr.customData.valueAddReservedQty }}/{{ attr.customData.valueAddTotalQty }}
                                            </Col>
                                        </Row>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </a>
                </template>
            </v-calendar>
            <!--仓库选择、底部的折线图 -->
            <div class="text-right margin-top-10">
                <span style="width:75px;display:inline-block">Warehouse</span>
                <div class="ivu-date-picker margin-left-10" style="width:200px;position:relative">
                    <vSelect v-model="warehouseCodes" filterable clearable multiple class="text-left">
                        <vOption v-for="(item, index) in warehouseList" :key="index" :value="item.value">{{ item.label }}
                        </vOption>
                    </vSelect>
                </div>
                <vButton class="margin-left-10" theme="primary" @click="getAllDatas">Search</vButton>
            </div>

            </Col>



            <Col span="6">
            <div class="bg-fff" style="border:1px solid #b8c2cc;margin:0 10px">
                <div style="font-size:14px;margin:10px;border-bottom:1px solid #eaeaea;padding-bottom:10px">
                    Dashboard <span class="font-12">SelectDate：{{ chooseday }}</span>
                    <Tooltip content="Available Reservation and Total Reservation of FCL/LTL" placement="top"
                        max-width="190">
                        <span
                            class="color-primary font-12 margin-right-15">General：{{ FCLPT ? FCLPT.goodsType : 'FCL' }}:{{ FCLPT ? FCLPT.availableQty : 0 }}/{{ FCLPT ? FCLPT.totalQty : 0 }}</span>
                        <span
                            class="color-primary font-12 margin-right-15">{{ LTLPT ? LTLPT.goodsType : 'LTL' }}:{{ LTLPT ? LTLPT.availableQty : 0 }}/{{ LTLPT ? LTLPT.totalQty : 0 }}</span>
                        <br />
                        <span
                            class="color-success font-12 margin-right-15">Express：{{ FCLJJ ? FCLJJ.goodsType : 'FCL' }}:{{ FCLJJ ? FCLJJ.availableQty : 0 }}/{{ FCLJJ ? FCLJJ.totalQty : 0 }}</span>
                        <span
                            class="color-success font-12">{{ LTLJJ ? LTLJJ.goodsType : 'LTL' }}:{{ LTLJJ ? LTLJJ.availableQty : 0 }}/{{ LTLJJ ? LTLJJ.totalQty : 0 }}</span>
                    </Tooltip>
                </div>
                <div class="margin-5" style="max-height:557px;overflow: auto;">
                    <div v-for="(item, index) in workbench" :key="index" class="back-fff padding-10-0 margin-right-5"
                        :class="item.bookingType == 1 ? 'workbench-primary border-primary' : 'workbench-success border-success'">
                        <div style="display:flex;align-items: center;">
                            <div style="flex-grow: 1;align-items:center;width:70px"><span class="opera-title"
                                    :class="item.bookingType == 1 ? 'bg-primary' : 'bg-success'">{{ item.bookingType == 1 ?
                                        'General' : 'Express' }}</span></div>
                            <div style="flex-grow: 2;width:279px">
                                <div>Reservation No.{{ item.reserveInboundNo }} <img v-show="item.yqnFlag == 1"
                                        style="width:20px;display:inline-block" src="/img/yqnlogo.png"></img></div>
                                <div>Customer {{ findRenderLabel(getNextOrgList, item.organizationId) }}</div>
                                <div>Warehouse {{ findRenderLabel(warehouseList, item.orgWarehouseCode) }}</div>
                                <div>Container No.{{ item.containerNo }}</div>
                                <div>Inbound Plan No.{{ item.inboundNos }}</div>
                            </div>
                            <div style="flex-grow: 1;width:70px"><Button @click="queryDetail(item.id)">Query</Button></div>
                        </div>
                    </div>
                </div>
            </div>
            </Col>
        </Row>
        <div class="margin-top-15">
            <Row>
                <Col span="8" style="border-right:1px solid #eaeaea">
                <div class="padding-20">
                    <div style="color:#666">Total Reservation</div>
                    <div style="color:#333;font-size:28px;font-weight:bold">{{ datejsonall.qty }}</div>
                    <div style="color:#999">
                        <span v-if="datejsonall.ratio >= 0" class="margin-left-15 margin-right-15 font-14"
                            style="color:#19be6b;">
                            <Icon style="margin-right:5px" type="md-arrow-dropup" />{{ datejsonall.ratio }}%
                        </span>
                        <span v-else class="margin-left-15 margin-right-5 font-14" style="color:#ed3f14;">
                            <Icon style="margin-right:5px" type="md-arrow-dropdown" />{{ datejsonall.ratio }}%
                        </span>
                        Compare with last month
                        <span v-if="datejsonall.weekRatio >= 0" class="margin-left-20 font-14" style="color:#333;">
                            {{ datejsonall.lastTermQty }}
                        </span>
                        Last Month Total Reservation
                    </div>
                    <div style="color:#999">
                        <span v-if="datejsonall.weekRatio >= 0" class="margin-left-15 margin-right-15 font-14"
                            style="color:#19be6b;">
                            <Icon style="margin-right:5px" type="md-arrow-dropup" />{{ datejsonall.weekRatio }}%
                        </span>
                        <span v-else class="margin-left-15 margin-right-5 font-14" style="color:#ed3f14;">
                            <Icon style="margin-right:5px" type="md-arrow-dropdown" />{{ datejsonall.weekRatio }}%
                        </span>
                        Link comparison results of this week and last week
                    </div>
                </div>
                <div id="LineAll" style="height: 300px;width:100%"></div>
                </Col>
                <Col span="8" style="border-right:1px solid #eaeaea">
                <div class="padding-20">
                    <div style="color:#666">General Reservation</div>
                    <div style="color:#333;font-size:28px;font-weight:bold">{{ datejsonnormal.qty }}</div>
                    <div style="color:#999">
                        <span v-if="datejsonnormal.ratio >= 0" class="margin-left-15 margin-right-15 font-14"
                            style="color:#19be6b;">
                            <Icon style="margin-right:5px" type="md-arrow-dropup" />{{ datejsonnormal.ratio }}%
                        </span>
                        <span v-else class="margin-left-15 margin-right-5 font-14" style="color:#ed3f14;">
                            <Icon style="margin-right:5px" type="md-arrow-dropdown" />{{ datejsonnormal.ratio }}%
                        </span>
                        Compare with last month
                        <span v-if="datejsonnormal.weekRatio >= 0" class="margin-left-20 font-14" style="color:#333;">
                            {{ datejsonnormal.lastTermQty }}
                        </span>
                        Last Month Total Reservation
                    </div>
                    <div style="color:#999">
                        <span v-if="datejsonnormal.weekRatio >= 0" class="margin-left-15 margin-right-15 font-14"
                            style="color:#19be6b;">
                            <Icon style="margin-right:5px" type="md-arrow-dropup" />{{ datejsonnormal.weekRatio }}%
                        </span>
                        <span v-else class="margin-left-15 margin-right-5 font-14" style="color:#ed3f14;">
                            <Icon style="margin-right:5px" type="md-arrow-dropdown" />{{ datejsonnormal.weekRatio }}%
                        </span>
                        Link comparison results of this week and last week
                    </div>
                </div>
                <div id="LineNormal" style="height: 300px;width:100%"></div>
                </Col>
                <Col span="8">
                <div class="padding-20">
                    <div style="color:#666">Express Reservation</div>
                    <div style="color:#333;font-size:28px;font-weight:bold">{{ datejsonreserve.qty }}</div>
                    <div style="color:#999">
                        <span v-if="datejsonreserve.ratio >= 0" class="margin-left-15 margin-right-15 font-14"
                            style="color:#19be6b;">
                            <Icon style="margin-right:5px" type="md-arrow-dropup" />{{ datejsonreserve.ratio }}%
                        </span>
                        <span v-else class="margin-left-15 margin-right-5 font-14" style="color:#ed3f14;">
                            <Icon style="margin-right:5px" type="md-arrow-dropdown" />{{ datejsonreserve.ratio }}%
                        </span>
                        Compare with last month
                        <span v-if="datejsonreserve.weekRatio >= 0" class="margin-left-20 font-14" style="color:#333;">
                            {{ datejsonreserve.lastTermQty }}
                        </span>
                        Last Month Total Reservation
                    </div>
                    <div style="color:#999">
                        <span v-if="datejsonreserve.weekRatio >= 0" class="margin-left-15 margin-right-15 font-14"
                            style="color:#19be6b;">
                            <Icon style="margin-right:5px" type="md-arrow-dropup" />{{ datejsonreserve.weekRatio }}%
                        </span>
                        <span v-else class="margin-left-15 margin-right-5 font-14" style="color:#ed3f14;">
                            <Icon style="margin-right:5px" type="md-arrow-dropdown" />{{ datejsonreserve.weekRatio }}%
                        </span>
                        Link comparison results of this week and last week
                    </div>
                </div>
                <div id="LineReserve" style="height: 300px;width:100%"></div>
                </Col>
            </Row>
        </div>
        <!-- 弹框 -->
        <compModal v-model="modalProps.show" v-bind="modalProps" @on-close="modalProps = {}">
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on"
                @on-close="modalProps = {}"></component>
        </compModal>
    </div>
</template>

<script>
import { HttpGetDateReport, HttpGetReserveCount, HttpGetListByDate, HttpBespeakWarehouses, HttpGetReserveDataByDate } from "@/service/bespeak";
import { mapGetters } from "vuex";
import comIndex from '../detail'
export default {
    components: {
        comIndex
    },
    data() {
        const month = new Date().getMonth();
        const year = new Date().getFullYear();
        return {
            warehouseCodes: [],
            masks: {
                weekdays: 'WWW',
            },
            attributes: [],
            datejsonall: {},
            datejsonnormal: {},
            datejsonreserve: {},
            workbench: [],
            warehouseList: [],
            dayone: '',
            modalProps: {},
            allQty: [],
            chooseday: 'Current Month',
            FCLPT: {},
            FCLJJ: {},
            LTLPT: {},
            LTLJJ: {},
        }
    },
    created() {
        let dayarr = this.getDay(0).split('-');
        this.dayone = dayarr[0] + '-' + dayarr[1] + '-01'
        this.getWarehouse();
        this.getAllDatas();
    },
    mounted() {

    },
    computed: {
        ...mapGetters('dictionary', ['getNextOrgList']),
    },
    methods: {
        getWarehouse() {
            HttpBespeakWarehouses({
                orgRoleName: 'WAREHOUSE'
            }).then(res => {
                this.warehouseList = res.data.map(item => {
                    const { id, title, code } = item;
                    return {
                        value: code,
                        label: `${title}(${code})`
                    };
                });
            });
        },
        chooseOneDay(val) {
            let calendardates = this.$refs.reservatecalendar
            // 重新渲染页面内容
            console.log(calendardates, 'calendardates')
            let date = calendardates.pages[0].key.split('-')
            if (date[1] < 10) {
                this.dayone = date[0] + '-0' + date[1] + '-01'
            } else {
                this.dayone = date[0] + '-' + date[1] + '-01'
            }
            this.getAllDatas()

        },
        // 选择日期请求侧边栏
        choseDayOne(day) {
            this.chooseday = day.id;
            HttpGetListByDate({
                localDate: day.id,
                warehouseCodes: this.warehouseCodes.length === 0 ? [] : this.warehouseCodes,
                rows: 1000,
            }).then(res => {
                this.workbench = res.data.content
            }, err => {
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            this.getAllQty(day.id)
        },
        getAllDatas(date, warehouseCode) {
            // 侧边工作台清空
            this.workbench = [];
            // 日历
            HttpGetDateReport({
                date: this.dayone,
                warehouseCodes: this.warehouseCodes.length === 0 ? [] : this.warehouseCodes,
            }).then(res => {
                let newarr = []
                for (let key in res.data) {
                    if (res.data[key].normalTotalQty > 0 || res.data[key].valueAddTotalQty > 0) {
                        newarr.push({
                            dates: res.data[key].date,
                            customData: res.data[key]
                        })
                    }
                }
                // attributes
                this.attributes = newarr

            }, err => {
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            // 底部折线
            HttpGetReserveCount({
                date: this.dayone,
                warehouseCodes: this.warehouseCodes.length === 0 ? [] : this.warehouseCodes,
            }).then(res => {
                console.log(res)
                // 底部折现数据处理
                this.handleLine(res.data)
            }, err => {
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            this.getAllQty(this.dayone)
        },
        getAllQty(date) {
            // 请求总的预约量
            HttpGetReserveDataByDate({
                localDate: date,
                warehouseCodes: this.warehouseCodes.length === 0 ? [] : this.warehouseCodes,
            }).then(res => {
                this.allQty = res.data
                this.FCLPT = this.FCLJJ = this.LTLPT = this.LTLJJ = null;
                this.allQty.map(item => {
                    if (item.goodsType == 'FCL' && item.bookingType == 1) {
                        this.FCLPT = item || {}
                    }
                    if (item.goodsType == 'FCL' && item.bookingType == 0) {
                        this.FCLJJ = item || {}
                    }
                    if (item.goodsType == 'LTL' && item.bookingType == 1) {
                        this.LTLPT = item || {}
                    }
                    if (item.goodsType == 'LTL' && item.bookingType == 0) {
                        this.LTLJJ = item || {}
                    }
                })
            })
        },
        handleLine(data) {
            let datearrall = [], datearrnormal = [], datearrreserve = [];
            let numall = [], numnormal = [], numreserve = [];
            this.datejsonall = {
                qty: data.totalReserveMap.qty,
                ratio: data.totalReserveMap.ratio,
                lastTermQty: data.totalReserveMap.lastTermQty,
                weekRatio: data.totalReserveMap.weekRatio,
            }
            this.datejsonnormal = {
                qty: data.normalReserveMap.qty,
                ratio: data.normalReserveMap.ratio,
                lastTermQty: data.normalReserveMap.lastTermQty,
                weekRatio: data.normalReserveMap.weekRatio,
            }
            this.datejsonreserve = {
                qty: data.valueAddReserveMap.qty,
                ratio: data.valueAddReserveMap.ratio,
                lastTermQty: data.valueAddReserveMap.lastTermQty,
                weekRatio: data.valueAddReserveMap.weekRatio,
            }
            let totaljson = data.totalReserveMap.dayCountMap
            for (let key in totaljson) {
                datearrall.push(totaljson[key].date);
                numall.push(totaljson[key].qty)
            }
            let normaljson = data.normalReserveMap.dayCountMap
            for (let key in normaljson) {
                datearrnormal.push(normaljson[key].date);
                numnormal.push(normaljson[key].qty)
            }
            let reservejson = data.valueAddReserveMap.dayCountMap
            for (let key in reservejson) {
                datearrreserve.push(reservejson[key].date);
                numreserve.push(reservejson[key].qty)
            }
            // 开始画折现图
            this.drawLineAll(datearrall, numall);
            this.drawLineNormal(datearrnormal, numnormal);
            this.drawLineReserve(datearrreserve, numreserve);
        },
        drawLineAll(datevalue, numvalue) {
            let lineAllGraph = Echarts.init(document.getElementById('LineAll'));
            // 绘制图表
            lineAllGraph.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                xAxis:
                {
                    show: false,
                    type: 'category',
                    boundaryGap: false,
                    data: datevalue
                },
                yAxis: {
                    show: false,
                    type: 'value',
                },
                grid: {
                    top: '3%',
                    left: '3%',
                    right: '3%',
                    containLabel: true
                },
                color: ['#f90'],
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            width: 1
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.4,
                            // color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            // {
                            //     offset: 0,
                            //     color: 'rgb(255, 191, 0)'
                            // },
                            // {
                            //     offset: 1,
                            //     color: 'rgb(224, 62, 76)'
                            // }
                            // ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: numvalue
                    },
                ]
            })
            // 处理浏览器窗口缩放问题
            window.addEventListener("resize", () => {
                if (lineAllGraph) {
                    lineAllGraph.resize()
                }
            })
        },
        drawLineNormal(datevalue, numvalue) {
            let lineNormalGraph = Echarts.init(document.getElementById('LineNormal'));
            // 绘制图表
            lineNormalGraph.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                xAxis:
                {
                    show: false,
                    type: 'category',
                    boundaryGap: false,
                    data: datevalue
                },
                yAxis: {
                    show: false,
                    type: 'value',
                },
                grid: {
                    top: '3%',
                    left: '3%',
                    right: '3%',
                    containLabel: true
                },
                color: ['#2d8cf0'],
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            width: 1
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.4,
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: numvalue
                    },
                ]
            })
            // 处理浏览器窗口缩放问题
            window.addEventListener("resize", () => {
                if (lineNormalGraph) {
                    lineNormalGraph.resize()
                }
            })
        },
        drawLineReserve(datevalue, numvalue) {
            let lineReserveGraph = Echarts.init(document.getElementById('LineReserve'));
            // 绘制图表
            lineReserveGraph.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                xAxis:
                {
                    show: false,
                    type: 'category',
                    boundaryGap: false,
                    data: datevalue
                },
                yAxis: {
                    show: false,
                    type: 'value',
                },
                grid: {
                    top: '3%',
                    left: '3%',
                    right: '3%',
                    containLabel: true
                },
                color: ['#19be6b'],
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            width: 1
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.4,
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: numvalue
                    },
                ]
            })
            // 处理浏览器窗口缩放问题
            window.addEventListener("resize", () => {
                if (lineReserveGraph) {
                    lineReserveGraph.resize()
                }
            })
        },
        // 查看单条数据
        queryDetail(params) {
            this.modalProps = {
                title: 'Query',
                show: true,
                width: 1200,
                component: "comIndex",
                activeid: params,
                querytype: 'query',
                orgName: 'WAREHOUSE',//这个按照custom来传，看后续产品是否要改变,已改成manage
                showFooter: false

            }
        }
    }
}
</script>
